import {
    Box,
    Button,
    Card,
    Container,
    Flex,
    Grid,
    MultiSelect,
    Portal,
    Select,
    Stack,
    Text,
    Title,
} from '@mantine/core';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import { WidgetSection } from '.';
import dayjs from 'dayjs';
import { pascalToFriendly } from '../../../../../utils/text';

const AgentInfo = ({ agent }) => {
    const {
        state = {},
        simcard = {},
        imsState = {},
        containerState = {},
    } = agent;
    return (
        <Card
            withBorder
            radius='md'
            px='md'
            className={null}>
            <Title
                order={5}
                c={'dimmed'}>
                Agent Info
            </Title>
            <Card.Section
                className={null}
                px={'md'}
                py='xs'>
                <Stack gap={5}>
                    <WidgetSection
                        title={'Name'}
                        value={
                            agent.subName
                                ? `${agent.name}-${agent.subName}`
                                : agent.name
                        }
                        badgeValue={agent.connectionStatus}
                    />

                    <WidgetSection
                        title={'Hub'}
                        value={agent.hub}
                    />

                    {agent.type === 'Modem' ? (
                        <WidgetSection
                            title={'Modem'}
                            value={state?.product}
                            badgeValue={state?.vendor}
                        />
                    ) : null}

                    <WidgetSection
                        title={'Iccid'}
                        value={state?.iccid}
                        badgeValue={simcard?.carrier}
                    />

                    <WidgetSection
                        title={'Imei'}
                        value={state?.imei}
                        badgeValue={
                            simcard?.mobileDevice
                                ? simcard.mobileDevice.modelIdentifier
                                : null
                        }
                    />

                    <WidgetSection
                        title={'Cpsi'}
                        value={state?.cpsi?.rawCpsi}
                    />

                    <WidgetSection
                        title={'Number'}
                        value={simcard?.number}
                        badgeValue={simcard?.carrier}
                    />

                    <WidgetSection
                        title={'Health Status'}
                        value={''}
                        badgeValue={pascalToFriendly(state?.healthStatus)}
                    />

                    <WidgetSection
                        title={'Sim Status'}
                        value={''}
                        badgeValue={pascalToFriendly(simcard?.status)}
                    />

                    <WidgetSection
                        title={'Network Status'}
                        value={''}
                        badgeValue={pascalToFriendly(state?.lteStatus)}
                    />

                    <WidgetSection
                        title={'IMS Status'}
                        badgeValue={imsState?.connected || 'Disconnected'}
                    />
                    <WidgetSection
                        title={'Version'}
                        badgeValue={containerState?.version}
                    />

                    <WidgetSection
                        title={'Last Seen'}
                        badgeValue={dayjs(agent.lastSeen).format('L LTS')}
                    />
                </Stack>
            </Card.Section>
        </Card>
    );
};
export default AgentInfo;
